import React from 'react'
import { render } from 'react-dom'
import { QueryClientProvider } from 'react-query'

import queryClient from './queryClient'
import { PublicVideoPreviewPage } from './PersonalNew/components/video-preview-public/PublicVideoPreviewPage'
import { bootstrapPersonalVideoPreview } from './PersonalNew/components/video-preview-public/personalPageBootstrap'
import { SiteProvider } from './sharedLegacy/context/SiteContext'

let reactContainerNode = document.querySelector('.react-container')
if (!reactContainerNode) {
  reactContainerNode = document.getElementById('main_container')
}

if (reactContainerNode) {
  void bootstrapPersonalVideoPreview({
    pathname: window.location.pathname,
    origin: window.location.origin,
    setQueryData: (key, value) => queryClient.setQueryData(key, value),
    renderPreview: ({ videoId, videoToken, siteUrl }) => {
      render(
        <QueryClientProvider client={queryClient}>
          <SiteProvider value={{ site_url: siteUrl }}>
            <PublicVideoPreviewPage
              videoId={videoId}
              videoToken={videoToken}
              siteUrl={siteUrl}
            />
          </SiteProvider>
        </QueryClientProvider>,
        reactContainerNode
      )
    },
  })
}
